import type { Tabs } from "features/merchantPayouts/types";

export const enum MerchantPayoutsTabs {
    SummaryFiles = 'SummaryFiles',
    Files = 'Files',
    Calculations = 'Calculations',
    Increments = 'Increments',
    IncrementsPivot = 'IncrementsPivot',
    FileTaxCalculations = 'FileTaxCalculations',
    IncrementsTaxCalculations = 'IncrementsTaxCalculations',
    IncrementExchangeRates = 'IncrementExchangeRates'
}

export const Filters = {
    coreId: 'coreId',
    fileKey: 'fileKey',
    via: 'via',
    MOR: 'MOR',
    merchantId: 'merchantId',
    merchantName: 'merchantName',
    currency: 'currency',
    rollingReserveRetainedPaidInFileId: 'rollingReserveRetainedPaidInFileId',
    PSP: 'PSP',
    calculationStatus: 'calculationStatus',
    incrementStatus: 'incrementStatus',
    methodId: 'methodId',
    merchantPayoutCalculationId: 'merchantPayoutCalculationId',
    idOfTransaction: 'idOfTransaction',
    initialTransactionId: 'initialTransactionId',
    merchantPayoutIncId: 'merchantPayoutIncId',
    merchantPayoutFileId: 'merchantPayoutFileId',
    taxName: 'taxName',
    tag: 'tag',
    dateFrom: 'dateFrom',
    dateTo: 'dateTo',
    transactionCurrency: 'transactionCurrency',
    currencyExchangeRate: 'currencyExchangeRate',
    payoutCurrency: 'payoutCurrency',
    isPaid: 'isPaid',
    refColFrom:"refColFrom",
    refColFromMinSum:"refColFromMinSum",
    currentIncMultiplierForEachRefColumn:"currentIncMultiplierForEachRefColumn",
    parentId: 'parentId',
    amountPaid: 'amountPaid'
};

export const merchantPayoutTabValueMapping = new Map<string, Tabs>([
    ['1', MerchantPayoutsTabs.SummaryFiles],
    ['2', MerchantPayoutsTabs.Files],
    ['3', MerchantPayoutsTabs.Calculations],
    ['4', MerchantPayoutsTabs.FileTaxCalculations],
    ['5', MerchantPayoutsTabs.IncrementsPivot],
    ['6', MerchantPayoutsTabs.IncrementsTaxCalculations],
    ['7', MerchantPayoutsTabs.Increments],
    ['8', MerchantPayoutsTabs.IncrementExchangeRates]
]);

export const enum FeesMethodsCategory {
    General = 'null'
};

export const enum MethodFees {
    MerchantDiscountRate = 'MDR',
    TransactionFee = 'Transaction Fee',
    RollingReserve = 'Rolling Reserve',
    RefundFee = 'Refund Fee'
};
